/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PaginatedProductList } from '../models/paginated-product-list';
import { Product } from '../models/product';
import { productsList } from '../fn/products/products-list';
import { ProductsList$Params } from '../fn/products/products-list';
import { productsRetrieve } from '../fn/products/products-retrieve';
import { ProductsRetrieve$Params } from '../fn/products/products-retrieve';

@Injectable({ providedIn: 'root' })
export class ProductsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `productsList()` */
  static readonly ProductsListPath = '/msp/api/products/';

  /**
   * Provides read-only access to Products for anyone.
   * Non-Admin users will see only the final version of each product in the list.
   * Also, individual historic Product Versoins are available to logged-in users who
   * had bought that  Product before.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  productsList$Response(params?: ProductsList$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedProductList>> {
    return productsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Provides read-only access to Products for anyone.
   * Non-Admin users will see only the final version of each product in the list.
   * Also, individual historic Product Versoins are available to logged-in users who
   * had bought that  Product before.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productsList(params?: ProductsList$Params, context?: HttpContext): Observable<PaginatedProductList> {
    return this.productsList$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaginatedProductList>): PaginatedProductList => r.body)
    );
  }

  /** Path part for operation `productsRetrieve()` */
  static readonly ProductsRetrievePath = '/msp/api/products/{id}/';

  /**
   * Provides read-only access to Products for anyone.
   * Non-Admin users will see only the final version of each product in the list.
   * Also, individual historic Product Versoins are available to logged-in users who
   * had bought that  Product before.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  productsRetrieve$Response(params: ProductsRetrieve$Params, context?: HttpContext): Observable<StrictHttpResponse<Product>> {
    return productsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Provides read-only access to Products for anyone.
   * Non-Admin users will see only the final version of each product in the list.
   * Also, individual historic Product Versoins are available to logged-in users who
   * had bought that  Product before.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productsRetrieve(params: ProductsRetrieve$Params, context?: HttpContext): Observable<Product> {
    return this.productsRetrieve$Response(params, context).pipe(
      map((r: StrictHttpResponse<Product>): Product => r.body)
    );
  }

}
